export const resolveSelectedRankingRoster = ({
  availableRosters = [],
  selectedRoster = null,
  favoriteRoster = null,
}) => {
  if (selectedRoster && availableRosters.includes(selectedRoster)) {
    return selectedRoster;
  }

  if (favoriteRoster && availableRosters.includes(favoriteRoster)) {
    return favoriteRoster;
  }

  return availableRosters[0] || null;
};
